module.exports = "https://assets.localphysio.net.au/_next/static/images/google-rating-4f60a5f7b2148ad524eb01304a7eef87.png";